export const validateAmountLimits = (value: string | number, max: number, min = 0) => {
	const amount = Number(value);

	return amount >= min && amount <= max;
};
